/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Result } from '../../interfaces';
import { Api } from './axios-config/ApiConfig';

const AddAsync = async (dto: any, entity: string): Promise<any | Error> => {
    try {
        const { data } = await Api.post(`/api/${entity}/AddAsync`, dto);
        if (data) {
            return data;
        }
        return new Error('Enable to add record. Contact then administrator.');
    } catch (error: any) {
        console.error(error);
        return new Error((error as { mesage: string }).mesage || 'Enable to add record');
    }
};

const GetByIdAsync = async (id: string, entity: string): Promise<any | Error> => {
    try {
        const parms = entity.split('.');

        const { data } = await Api.get(`/${parms[0]}/api/${parms[1]}/GetByIdAsync?${id}`);
        if (data) {
            return data;
        }
        return new Error('Enable to get by id. Contact the administrator.');
    } catch (error: any) {
        console.error(error);
        return new Error((error as { mesage: string }).mesage || 'Enable to get by Id record. Contact the administrator');
    }
};

const GetAllAsync = async (filter: any, entity: string): Promise<any | Error> => {
    try {
        const parms = entity.split('.');

        const { data } = await Api.post(`/${parms[0]}/api/${parms[1]}/GetAllAsync`, filter);
        if (data) {
            return data;
        }
        return new Error('Enable to get all records. Contact the administrator.');
    } catch (error) {
        console.error(error);
        return new Error((error as { mesage: string }).mesage || 'Enable to get all records. Contact the administrator');
    }
};

const GetAllViewAsync = async (filter: any, entity: string): Promise<any | Error> => {
    try {
        const { data } = await Api.post(`/api/${entity}/GetAllViewAsync`, filter);
        if (data) {
            return data;
        }
        return new Error('Enable the geet all view records. Contact the administrator');
    } catch (error: any) {
        console.error(error);
        return new Error((error as { mesage: string }).mesage || 'Enable to get all view records. Contact the administrator');
    }
};

const UpdateAsync = async (dto: any, entity: string): Promise<any | Error> => {
    try {

        const { data } = await Api.put(`/api/${entity}/UpdateAsync`, dto);
        if (data) {
            return data;
        }
        return new Error('Enable to update record. Contact the administrator.');
    } catch (error: any) {
        console.error(error);
        return new Error((error as { mesage: string }).mesage || 'Enable to update record. Contact the administrator.');
    }
};

const DeleteAsync = async (id: string, entity: string): Promise<any | Error> => {
    try {
        const parms = entity.split('.');

        const { data } = await Api.delete(`/${parms[0]}/api/${parms[1]}/DeleteAsync?${id}`);
        if (data) {
            return data;
        }
        return new Error('Enable to delete record. Contact the administrator');
    } catch (error: any) {
        console.error(error);
        return new Error((error as { mesage: string }).mesage || 'Enable to delete record. Contact the administrator');
    }
};

const GetGenericAsync = async (method: string, entity: string, filter?: any): Promise<any | Error> => {
    try {
        const { data } = await Api.get(`/api/${entity}/${method}`, filter);
        if (data) {
            return data;
        }
        return new Error('Enable to get generic records. Contact the administrator.');
    } catch (error) {
        console.error(error);
        return new Error((error as { mesage: string }).mesage || 'Enable to get generic records. Contact the administrator');
    }
};

const PostGenericAsync = async (method: string, dto: any, entity: string): Promise<any | Error> => {
    try {
        const { data } = await Api.post(`/api/${entity}/${method}`, dto);
        if (data) {
            return data;
        }
        return new Error('Enable to add record. Contact then administrator.');
    } catch (error: any) {
        console.error(error);
        return new Error((error as { mesage: string }).mesage || 'Enable to add record');
    }
};

async function AddAsync1<T>(
    entity: string,
    dto: T,
    setDTO: (value: T) => void,
    setActionExecuted: (value: true) => void,
    setLoading: (value: boolean) => void,
    showMessage: (message: string, type: 'error' | 'info' | 'success' | 'warning') => void,
) {

    try {
        setLoading(true);

        const parms = entity.split('.');

        const { data } = await Api.post(`/${parms[0]}/api/${parms[1]}/AddAsync`, dto);

        const result: Result<T> = data;

        if (result instanceof Error) { throw new Error(result.message); }

        if (result.code === 201 && result.value !== null) {
            setActionExecuted(true);
            setDTO(result.value);

            showMessage(result.info, 'success');
        }
        else {
            console.warn(result.code + ' - ' + result.error);
            showMessage(result.info, 'warning');
        }
        setLoading(false);
    } catch (error) {
        console.error(error);
        setLoading(false);
        showMessage(String(error), 'error');
    }
}

async function CloneAsync1<T>(
    entity: string,
    dto: T,
    setDTO: (value: T) => void,
    setActionExecuted: (value: true) => void,
    setLoading: (value: boolean) => void,
    showMessage: (message: string, type: 'error' | 'info' | 'success' | 'warning') => void,
) {

    try {
        setLoading(true);

        const parms = entity.split('.');

        const { data } = await Api.post(`/${parms[0]}/api/${parms[1]}/CloneAsync`, dto);

        const result: Result<T> = data;

        if (result instanceof Error) { throw new Error(result.message); }

        if (result.code === 201 && result.value !== null) {
            setActionExecuted(true);
            setDTO(result.value);

            showMessage(result.info, 'success');
        }
        else {
            console.warn(result.code + ' - ' + result.error);
            showMessage(result.info, 'warning');
        }
        setLoading(false);
    } catch (error) {
        console.error(error);
        setLoading(false);
        showMessage(String(error), 'error');
    }
}

async function GetByIdAsync1<T>(
    entity: string,
    id: string,
    setLoading: (value: boolean) => void,
    setDTO: (value: T) => void,
    showMessage: (message: string, type: 'error' | 'info' | 'success' | 'warning') => void

) {
    if (id === '' || id === undefined) {
        return;
    }

    try {
        setLoading(true);

        const parms = entity.split('.');

        const { data } = await Api.get(`/${parms[0]}/api/${parms[1]}/GetByIdAsync?id=${id}`);

        const result: Result<T> = data;

        if (result instanceof Error) { throw new Error(result.message); }

        if (result.code === 200 && result.value !== null) {
            setDTO(result.value);
        }
        else {
            console.warn(result.code + ' - ' + result.error);
            showMessage(result.info, 'warning');
        }
        setLoading(false);
    } catch (error) {
        console.error(error);
        setLoading(false);
        showMessage(String(error), 'error');
    }
}

async function GetAllAsync1<T, TFilter>(
    entity: string,
    filter: TFilter,
    setLoading: (value: boolean) => void,
    setDTO: (value: T) => void,
    showMessage: (message: string, type: 'error' | 'info' | 'success' | 'warning') => void,
    hasLoading?: boolean | true
) {
    try {
        hasLoading && setLoading(true);

        const parms = entity.split('.');

        const { data } = await Api.post(`/${parms[0]}/api/${parms[1]}/GetAllAsync`, filter);

        const result: Result<T> = data;

        if (result instanceof Error) { throw new Error(result.message); }

        if (result.code === 200 && result.value !== null) {
            setDTO(result.value);
        }
        else {
            console.warn(result.code + ' - ' + result.error);
            showMessage(result.info, 'warning');
        }
        hasLoading && setLoading(false);
    } catch (error) {
        console.error(error);
        setLoading(false);
        showMessage(String(error), 'error');
    }
}

async function GetAllViewAsync1<T, TFilter>(
    entity: string,
    filter: TFilter,
    setActionExecuted: (value: boolean) => void,
    setLoading: (value: boolean) => void,
    setDTO: (value: T) => void,
    showMessage: (message: string, type: 'error' | 'info' | 'success' | 'warning') => void,
    hasLoading?: boolean | true

) {
    try {
        hasLoading && setLoading(true);

        setActionExecuted(false);

        const parms = entity.split('.');

        const { data } = await Api.post(`/${parms[0]}/api/${parms[1]}/GetAllViewAsync`, filter);

        const result: Result<T> = data;

        if (result instanceof Error) { throw new Error(result.message); }

        if (result.code === 200 && result.value !== null) {
            setDTO(result.value);
        }
        else {
            console.warn(result.code + ' - ' + result.error);
            showMessage(result.info, 'warning');
        }
        hasLoading && setLoading(false);
    } catch (error) {
        console.error(error);
        setLoading(false);
        showMessage(String(error), 'error');

    }
}

async function UpdateAsync1<T>(
    entity: string,
    dto: T,
    setActionExecuted: (value: true) => void,
    setLoading: (value: boolean) => void,
    showMessage: (message: string, type: 'error' | 'info' | 'success' | 'warning') => void,
    hasLoading?: boolean | true

) {

    try {
        hasLoading && setLoading(true);

        const parms = entity.split('.');

        const { data } = await Api.put(`/${parms[0]}/api/${parms[1]}/UpdateAsync`, dto);

        const result: Result<T> = data;

        if (result instanceof Error) { throw new Error(result.message); }

        if (result.code === 200 && result.value !== null) {
            setActionExecuted(true);
            showMessage(result.info, 'success');
        }
        else {
            console.warn(result.code + ' - ' + result.error);
            showMessage(result.info, 'warning');
        }
        hasLoading && setLoading(false);
    } catch (error) {
        console.error(error);
        setLoading(false);
        showMessage(String(error), 'error');

    }
}

async function DeleteAsync1<T>(
    entity: string,
    id: string,
    setLoading: (value: boolean) => void,
    setDTO: (value: T) => void,
    showMessage: (message: string, type: 'error' | 'info' | 'success' | 'warning') => void

) {
    if (id === '' || id === undefined) {
        return;
    }

    try {
        setLoading(true);

        const parms = entity.split('.');

        const { data } = await Api.delete(`/${parms[0]}/api/${parms[1]}/DeleteAsync?id=${id}`);

        const result: Result<T> = data;

        if (result instanceof Error) { throw new Error(result.message); }

        if (result.code === 200 && result.value === null) {
            setDTO(result.value);
            showMessage(result.info, 'success');
        }
        else if (result.code === 200 && result.value !== null) {
            setDTO(result.value);
            showMessage(result.info, 'success');
        }
        else {
            console.warn(result.code + ' - ' + result.error);
            showMessage(result.info, 'warning');
        }
        setLoading(false);
    } catch (error) {
        console.error(error);
        setLoading(false);
        showMessage(String(error), 'error');
    }
}

async function PostGenericAsync1<T>(
    entity: string,
    method: string,
    dto: T,
    setActionExecuted: (value: true) => void,
    setLoading: (value: boolean) => void,
    showMessage?: (message: string, type: 'error' | 'info' | 'success' | 'warning') => void | undefined,
    setDTO?: (value: T) => void | undefined 
) {

    try {
        setLoading(true);

        const parms = entity.split('.');

        const { data } = await Api.post(`/${parms[0]}/api/${parms[1]}/${method}`, dto);

        const result: Result<T> = data;

        if (result instanceof Error) { throw new Error(result.message); }

        // if (result.code === 200 && result.value !== null || result.code === 201 && result.value !== null) {
        if (result.code === 200 || result.code === 201) {
            setDTO != undefined ? setDTO(result.value) : undefined;
            setActionExecuted(true);

            showMessage != undefined ? showMessage(result.info, 'success') : undefined;
        }
        else {
            console.warn(result.code + ' - ' + result.error);
            showMessage != undefined ? showMessage(result.info, 'warning') : undefined;
        }
        setLoading(false);
    } catch (error) {
        console.error(error);
        setLoading(false);
        showMessage != undefined ? showMessage(String(error), 'error') : undefined;
    }
}

async function GetGenericAsync1<T>(
    entity: string,
    method: string,
    dto: T,
    setActionExecuted: (value: true) => void,
    setLoading: (value: boolean) => void,
    showMessage: (message: string, type: 'error' | 'info' | 'success' | 'warning') => void

) {

    try {
        setLoading(true);

        const parms = entity.split('.');

        const { data } = await Api.post(`/${parms[0]}/api/${parms[1]}/${method}`, dto);

        const result: Result<T> = data;

        if (result instanceof Error) { throw new Error(result.message); }

        if (result.code === 200 && result.value !== null || result.code === 201 && result.value !== null) {
            setActionExecuted(true);

            showMessage(result.info, 'success');
        }
        else {
            console.warn(result.code + ' - ' + result.error);
            showMessage(result.info, 'warning');
        }
        setLoading(false);
    } catch (error) {
        console.error(error);
        setLoading(false);
        showMessage(String(error), 'error');
    }
}

export const GenericService = {
    AddAsync,
    GetByIdAsync,
    GetAllAsync,
    GetAllViewAsync,
    UpdateAsync,
    DeleteAsync,
    GetGenericAsync,
    PostGenericAsync,
    AddAsync1,
    CloneAsync1,
    GetByIdAsync1,
    UpdateAsync1,
    GetAllAsync1,
    GetAllViewAsync1,
    DeleteAsync1,
    PostGenericAsync1,
    GetGenericAsync1
};